import { render, staticRenderFns } from "./ArchivoPlano.vue?vue&type=template&id=14a5d953"
import script from "./ArchivoPlano.vue?vue&type=script&lang=js"
export * from "./ArchivoPlano.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports